/**
 * Embed a Streamate camera ever 5 positions.
 */

import { useDeviceType } from "@/common/hooks/useDeviceType";
import { useFeedV2Store } from "@/common/store/useFeedV2Store";
import { deviceTypeEnum } from "@/common/utils/device";
import { clsx } from "clsx";
import { StreamateCamera } from "components/ads/StreamateCamera";
import { SnapOnly } from "components/utils/SnapOnly";
import { VisibleOnly } from "components/utils/VisibleOnly";

interface IProps {
  position: number;
  tags: string[];
}

export const StreamateCameraDispatcher = ({ position, tags }: IProps) => {
  const isV2Variant = useFeedV2Store((state) => state.isV2Variant);
  const isMobile = useDeviceType() === deviceTypeEnum.PHONE;

  return (
    <SnapOnly key={`streamate-camera-${position}`}>
      <VisibleOnly className={clsx("GifPreview", isV2Variant && isMobile && "GifPreviewV2")}>
        <StreamateCamera tags={tags} />
      </VisibleOnly>
    </SnapOnly>
  );
};
